import { WebStorageStateStore } from 'oidc-client-ts';
import env from '../../config/env';

const cognitoDomain = env.COGNITO_DOMAIN;
const clientId = env.COGNITO_CLIENT_ID;
const redirectUri = env.REDIRECT_URI;

console.log('🔧 [oidcConfig] Environment variables:', {
    cognitoDomain,
    clientId,
    redirectUri,
    allEnv: env
});

// Create a namespaced storage wrapper to prevent conflicts between apps/tabs
class NamespacedStorage implements Storage {
    private prefix: string;
    private storage: Storage;

    constructor(storage: Storage, prefix: string) {
        this.storage = storage;
        this.prefix = prefix;
    }

    get length(): number {
        return Object.keys(this.storage).filter(key => key.startsWith(this.prefix)).length;
    }

    clear(): void {
        Object.keys(this.storage).forEach(key => {
            if (key.startsWith(this.prefix)) {
                this.storage.removeItem(key);
            }
        });
    }

    getItem(key: string): string | null {
        return this.storage.getItem(this.prefix + key);
    }

    key(index: number): string | null {
        const keys = Object.keys(this.storage).filter(k => k.startsWith(this.prefix));
        const key = keys[index];
        return key ? key.substring(this.prefix.length) : null;
    }

    removeItem(key: string): void {
        this.storage.removeItem(this.prefix + key);
    }

    setItem(key: string, value: string): void {
        this.storage.setItem(this.prefix + key, value);
    }
}

// Create app-specific namespaced storage
const appNamespace = 'mentorship-ui:oidc:';
const namespacedStorage = new NamespacedStorage(window.localStorage, appNamespace);

const oidcConfig = {
    authority: `https://${cognitoDomain}`,
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: 'openid profile email',
    onSigninCallback: () => {
        console.log('🔧 [oidcConfig] onSigninCallback triggered');
        // Clean up query params but do not navigate away. AuthRoute will redirect after auth completes.
        window.history.replaceState({}, document.title, window.location.pathname);
    },
    userStore: new WebStorageStateStore({ store: namespacedStorage }),
    metadata: {
        issuer: `https://${cognitoDomain}`,
        authorization_endpoint: `https://${cognitoDomain}/oauth2/authorize`,
        token_endpoint: `https://${cognitoDomain}/oauth2/token`,
        end_session_endpoint: `https://${cognitoDomain}/logout`,
        jwks_uri: `https://${cognitoDomain}/.well-known/jwks.json`,
        userinfo_endpoint: `https://${cognitoDomain}/oauth2/userInfo`,
    },
};

console.log('🔧 [oidcConfig] Complete OIDC configuration:', oidcConfig);

export default oidcConfig;
